<div class="cardsContainer">
    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Main Info'"
            [highlight]="true"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.BuildingMainInfo]"
            #mainInfoCard
        >
        </lib-generic-card>

        <lib-generic-card
            [title]="'Additional Info'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.BuildingAdditionalInfo]"
            [hasArchivedItems]="productTypeHasArchived || usersHasArchived || companyHasArchived"
        >
        </lib-generic-card>
    </div>

    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Location'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.BuildingLocation]"
            #locationCard
        >
        </lib-generic-card>

        @if (
            cardsConfig[entityCardSection.BuildingCustomInfo] &&
            cardsConfig[entityCardSection.BuildingCustomInfo].length
        ) {
            <lib-generic-card
                [title]="'Custom Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.BuildingCustomInfo]"
                #customInfoCard
            >
            </lib-generic-card>
        }
    </div>
</div>
